import { getColumnIdFromCellKey } from '@/store/reducers/TableWidgetStore';
import { getTableRecommendationsStateForThreadSelector } from '@/store/reducers/TableRecommendationsStore';
import { RootState } from '@/store/store';

import { createSelector } from '@reduxjs/toolkit';

export const getExistingColumnCellValues = createSelector(
  [
    (state: RootState) =>
      getTableRecommendationsStateForThreadSelector(
        state.tableRecommendationsStore,
        state.UIState.currentThread?.id,
      ),
    (_, columnIds: Set<string>) => columnIds,
  ],
  (tableData, columnIds) => {
    if (!tableData) {
      return {};
    }

    // build map of column id to cell display value
    const existingCells: Record<string, string[]> = {};
    for (const cellKey in tableData.cells) {
      const columnId = getColumnIdFromCellKey(cellKey);
      const cellValue = tableData.cells[cellKey].displayValue;
      if (columnIds.has(columnId) && cellValue !== null) {
        existingCells[columnId] = [
          ...(existingCells[columnId] ?? []),
          `${cellValue}`,
        ];
      }
    }

    return existingCells;
  },
);
